import { createContext, useContext } from 'react'

export const MenuContext = createContext({
  isOpen: false,
  openMenu: () => {},
  closeMenu: () => {},
})

export function useMenuContext() {
  return useContext(MenuContext)
}
